import React from "react";
import Rollbar from '../utils/RollbarTracking'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Modal from 'react-responsive-modal';
import axios from 'axios'
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

import 'react-responsive-modal/styles.css';

export class Catalogues extends React.Component {

  constructor(props)  {
      super(props);
      this.handleChange = this.handleChange.bind(this);
  }

  state = {
      catalogues: [],
      name: '',
      modalOpen: false
  }

  handleChange (evt) {
    this.setState({ [evt.target.name]: evt.target.value });
  }

  filterChange(evt) {
    this.refs.nameFilter.applyFilter(evt.target.value);
  }

  componentWillMount() {
    this.fetchCatalogues();
  }

  addCatalogue = async () => {
    let requestParams = {
      'name': this.state.name,
    }
    axios.post('/catalogues', requestParams)
        .then(data => {
            this.closeModal()
            this.fetchCatalogues();
            toast.success('Catalogue Added!')
        })
        .catch (err => {
          console.error(err)
          Rollbar.error(err)
          toast.error('Failed to add new catalogue')
        })
  }

  fetchCatalogues = async () => {
    axios.get('/catalogues')
      .then(data => {
        this.setState({
          catalogues: data
        });
      })
      .catch (err => {
        console.error(err);
        Rollbar.error(err)
        toast.error('Failed to fetch catalogues')
      })
  }

  deleteCatalogue = async (catalogueID) => {
      axios.delete('/catalogues/' + catalogueID)
        .then(data => {
            this.fetchCatalogues();
        })
        .catch (err => {
          console.error(err);
          Rollbar.error(err)
          toast.error('Error: Catalogue is assigned to user, cannot delete.');
        })
  }

  cellButton(cell, row, enumObject, rowIndex) {
    return (
      <div>
        <button type="button" onClick={() => this.deleteCatalogue(row.catalogueID)} className="btn btn-danger btn-sm mar-right">Delete</button>
        <Link to={'/catalogues/edit/' + row.catalogueID}><button type="button" className="btn btn-info btn-sm">Edit</button></Link>
      </div>
    )
  }

  openModal = () => {
		this.setState({ modalOpen: true });
	};

	closeModal = () => {
		this.setState({ modalOpen: false });
	};

    render() {
        return (
          <div>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-1 mb-3 border-bottom">
              <h1 className="h3">Catalogues</h1>
            </div>
            <div className="row">
              <div className="col-sm-8 my-auto">
                <button type="button" className="btn btn-success btn-sm mar-bot" onClick={this.openModal} >Add Catalogue</button>
              </div>
              <div className="col-sm-4 my-auto">
                <div className="input-group mar-bot">
                  <div className="input-group-prepend">
                    <span className="input-group-text"><i className="fa fa-search"></i></span>
                  </div>
                  <input type="text" className="form-control" placeholder="Name..." onChange={this.filterChange.bind(this)}/>
                </div>
              </div>
            </div>
            <BootstrapTable data={this.state.catalogues} striped={true} hover={true} options={{sizePerPage: 50}} pagination>
              <TableHeaderColumn dataField="catalogueID" dataSort={true} isKey={true}>ID</TableHeaderColumn>
              <TableHeaderColumn ref='nameFilter' dataField="catalogueName" dataSort={true} filter={{ type: 'TextFilter' }}>Name</TableHeaderColumn>
              <TableHeaderColumn dataFormat={this.cellButton.bind(this)}>Action</TableHeaderColumn>
            </BootstrapTable>
            <Modal open={this.state.modalOpen} onClose={this.closeModal} center showCloseIcon={false} classNames={{ modal: 'modal' }}>
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Add Catalogue</h5>
                    <button type="button" className="close" onClick={this.closeModal}>
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="form-group">
                      <label>Catalogue Name:</label>
                      <input type="text" className="form-control" name="name" value={this.state.name} onChange={this.handleChange} />
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={this.closeModal}>Close</button>
                    <button type="button" onClick={this.addCatalogue} className="btn btn-primary" disabled={!this.state.name}>Save changes</button>
                  </div>
                </div>
              </div>
            </Modal>
          </div>
        );
    }
}
